module.exports = __webpack_public_path__ + "img/0Q3A5108-23_P_L_Foamcore_MockedUp.fb795477.jpg";